import React, { useContext } from 'react'
import { InlineWidget } from 'react-calendly'
import { UserContext } from '../../App'

const DemoTutorialCalendly = () => {
  const { user } = useContext(UserContext)

  return (
    <InlineWidget
      url="https://calendly.com/ambunet/demo"
      styles={{ height: '700px', minWidth: '320px' }}
      prefill={{
        name: `${user?.firstName || ''} ${user?.lastName || ''}`.trim(),
        email: user?.email || '',
      }}
    />
  )
}

export default DemoTutorialCalendly
